import { twMerge } from 'tailwind-merge';

import { Picture as SanityPictureProps } from '@root/sanity/sanity.types';
import Picture from 'components/Picture';
import { urlFor } from '@root/lib/sanity';
import TrackedLink from 'components/sanity/TrackedLink';

export type PromoNavItemType = {
  title: string;
  href?: string;
  alt?: string;
  image?: SanityPictureProps | string | undefined;
  trackerClass?: string;
} & ClassNameProp;

const PromoNavItem = ({ title, href, image, alt, trackerClass, className }: PromoNavItemType) => {
  const sanityImage = image as SanityPictureProps;
  const imageUrl = sanityImage?.asset ? urlFor(sanityImage.asset).url() : (image as string);

  return (
    <div className={twMerge('mx-48 my-32 overflow-hidden', className)}>
      <TrackedLink nav href={href ?? ''} className={trackerClass}>
        {image && <Picture noAspectRatioClass url={imageUrl} alt={alt ?? ''} focalPointY={0} />}
        <div className="mt-12 uppercase font-semibold">{title}</div>
      </TrackedLink>
    </div>
  );
};

export default PromoNavItem;
